import { signal, useComputed } from '@preact/signals-react';

import { freezign } from '~/lib/obj/mod.js';

import { compClass } from './EventSessionEntry.jsx';

const searchState = signal(''),
	set = (searchText = '') => {
		searchState.value = searchText;
	},
	clear = () => {
		set();
	},
	api = { set, clear };

const defaultMatchFn = () => true;

export const useGlobalSearch = (matchFn = defaultMatchFn) => {
	const matches = useComputed(() => matchFn(searchState.value));

	return [matches, api];
};

const ScheduleSearchItem = ({ node, data }) =>
	freezign(Object.create(ScheduleSearchItem.prototype), { node, data });

freezign(ScheduleSearchItem, {
	prototype: freezign({
		constructor: ScheduleSearchItem,
		matches(searchText) {
			return this.data.text.includes(searchText.trim().toLowerCase());
		},
	}),
});

export const createScheduleSearchIndex = () => {
	let init = false,
		lookup = null,
		list = null;

	return Object.freeze({
		init() {
			if (init) {
				return;
			}

			const scheduleEntries = Array.from(document.querySelectorAll(compClass.dot()));

			lookup = Object.freeze(
				scheduleEntries.reduce((acc, entry) => {
					const id = entry.id.replace('session-', ''),
						title = entry.querySelector(compClass.dot('header')).textContent,
						startTime = entry.querySelector(compClass.dot('start-time')).dateTime,
						endTime = entry.querySelector(compClass.dot('end-time')).dateTime,
						location = entry.querySelector(compClass.dot('location').concat(' dd')).textContent,
						description = entry.querySelector(compClass.dot('description')).textContent;

					acc[id] = ScheduleSearchItem({
						node: entry,
						data: {
							text: [title, location, description].join('||').toLowerCase(),
							id,
							title,
							location,
							description,
							startTime: new Date(startTime),
							endTime: new Date(endTime),
						},
					});

					return acc;
				}, {})
			);

			list = Object.freeze(Object.values(lookup));

			init = true;
		},
		matches(id, searchText) {
			if (!searchText) {
				return true;
			}

			return lookup[id]?.matches(searchText) ?? false;
		},
		search(searchText = '', onMatch = () => {}) {
			if (!init) {
				throw new Error('Search index has not been generated yet');
			}

			if (!searchText) {
				return;
			}
			const t = String(searchText).toLowerCase();

			lookup.forEach(entry => {
				if (entry.data.text.includes(t)) {
					onMatch(entry.node);
				}
			});
		},
	});
};
